document.addEventListener("DOMContentLoaded", function(event) {

  if( $('.header-banner-slider').length) {

    const slider =   $('.header-banner-slider');
  const slider_speed = slider.attr('data-slider_speed') * 1;
    const autoplay_slider = slider.attr('data-autoplay_slider') == "true" ? true :false;

     slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
         const animationParentEl = slider.closest('.header-banner');
       if(animationParentEl.length) {
         animationParentEl.addClass('completed_animation');
       
       }
    });
    
    slider.slick({
        infinite: true,
       autoplay: autoplay_slider,
    autoplaySpeed: slider_speed,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      nextArrow: '<div class="slick-button-next product-articles-slider-next" aria-label="Next">' + window.assets.icon_right + '</div>',
      prevArrow: '<div class="slick-button-prev product-articles-slider-prev" aria-label="Previous">' + window.assets.icon_left + '</div>'
    });
  }
  
function TotalLength(el){
  var path = document.querySelectorAll(el);
  if($(el).length > 0){
    for (let elem of path) {
      if(elem.getAttribute("stroke-dasharray")){
        var len = Math.round(elem.getTotalLength() );
        elem.setAttribute("stroke-dasharray", len);
        elem.setAttribute("stroke-dashoffset", len);
        elem.classList.add('draw');
      }
    }
  }
};

 var header_banner = $('.header-banner.with-animation');
  if(header_banner){
    header_banner.find('.z-top__header').css('opacity','1');
    TotalLength('#actuator-with-usp #Oval');
    TotalLength('#actuator-with-usp #Path');
    setTimeout(function() {
      header_banner.find('.z-top__text').css('opacity','1');
      header_banner.find('.header-content-icons-block svg').css('opacity','1');
      header_banner.find('.header-content-icons-block img').css('opacity','1');
      header_banner.find('#logo_actuators_landing').css('opacity','1');
      TotalLength('#actuator-icon-collection path');
      TotalLength('#actuator-icon-collection #Oval');
      TotalLength('#actuator-icon-collection #Path');
    }, 1000);
    setTimeout(function() {
      header_banner.find('.btn').css('opacity','1');
      header_banner.find('.swiper-container').css('opacity','1');
      header_banner.find('.brands-slide').css('opacity','1');
      TotalLength('#actuator-icon path');
      TotalLength('#actuator-icon #Oval');
      TotalLength('#product_icon #Path');
      TotalLength('#product_icon #Oval');
      header_banner.find('.header-content-icons-title').css('opacity','1');
      header_banner.find('.header-svg circle').css('opacity','1');
      header_banner.find('#actuator-with-usp .path-fill').addClass('full');
      header_banner.find('#actuator-with-usp .path-fill-dark').addClass('full');
    }, 2000);
    setTimeout(function() {
      header_banner.find('#actuator-icon .path-fill').addClass('full');
      header_banner.find('#product_icon .path-fill').addClass('full');
      header_banner.find('#product_icon .path-fill-dark').addClass('full');
      header_banner.find('#actuator-with-usp .path-fill-white').addClass('full');
    }, 2600);
  }
 });
